import { createApp } from 'vue'
import App from './app.vue'
import router from './router'
import store from './store'
import { AppInsights } from './appInsights'
// import { library } from '@fortawesome/fontawesome-svg-core'
// import { faFontAwesome } from '@fortawesome/free-brands-svg-icons'
// import { faSpinner } from '@fortawesome/free-solid-svg-icons'
// import { faInfoCircle, faTimesCircle, faExclamationCircle, faFilePdf } from '@fortawesome/pro-light-svg-icons'
// import { faAngleRight, faChevronRight, faTimes, faChevronDown } from '@fortawesome/pro-regular-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const appInsights = new AppInsights

appInsights.loadAppInsights()
// appInsights.trackPageView()

// library.add(
//   faFontAwesome,
//   faSpinner,
//   faInfoCircle,
//   faAngleRight,
//   faChevronRight,
//   faTimesCircle,
//   faExclamationCircle,
//   faFilePdf,
//   faTimes,
//   faChevronDown
// )

createApp(App)
// .component("font-awesome-icon", FontAwesomeIcon)
.use(store)
.use(router)
.mount('#app')
